import {Component, computed, input} from '@angular/core';
import moment from 'moment';
import {asDayOfWeek, DayOfWeek} from '../../../../classes/enums/DayOfWeek';
import {SHARED_IMPORTS} from "../../../../shared/standalone-imports";
import {RotaPageSwitchComponent} from "../../../../shared/components/rota-page-switch/rota-page-switch.component";

@Component({
  selector: 'app-rota-day-select',
  templateUrl: './rota-day-select.component.html',
  styleUrls: ['./rota-day-select.component.less'],
  imports: [SHARED_IMPORTS, RotaPageSwitchComponent]
})
export class RotaDaySelectComponent {

  /** An identifier of a week, for which a rota should be displayed. */
  weekId = input.required<string>();
  /** A date, for which the rota is displayed. */
  date = input.required<string>();

  /** The date, which is before the `date` signal. */
  previousDate = computed(() => moment(this.date()).subtract(1, 'days').format('YYYY-MM-DD'));
  /** The date, which is after the `date` signal. */
  nextDate = computed(() => moment(this.date()).add(1, 'days').format('YYYY-MM-DD'));

  /**
   * Returns `true` if the selected date is Monday.
   * @param date date of a rota.
   */
  isMonday(date: string): boolean {
    return asDayOfWeek(moment(date)) === DayOfWeek.MONDAY;
  }

  /**
   * Returns `true` if the selected date is Sunday.
   * @param date date of a rota.
   */
  isSunday(date: string): boolean {
    return asDayOfWeek(moment(date)) === DayOfWeek.SUNDAY;
  }
}